import Vue from 'vue';
import { cloneDeep as clone } from 'lodash';
import { mapState } from 'vuex';

const handleError = process.env.NODE_ENV === 'production';

const rightDrawer = {
  opened: false,
  permanent: false,
  clipped: false,
};

const leftDrawer = {
  opened: true,
  permanent: true,
  temporary: true,
  clipped: false,
  miniVariant: false,
  manuallySwitched: false,
};

const topBar = {
  opened: true,
};

const globalMixin = {
  methods: {
    clone,
  },
};

if (handleError) {
  Vue.config.errorHandler = function(err, vm, info) {
    console.error({
      error: err,
      vm,
      info,
    });

    return false;
  };

  Vue.config.warnHandler = function(msg, vm, trace) {
    console.warn({
      error: msg,
      vm,
      trace,
    });

    return false;
  };

  Vue.mixin({
    errorCaptured(err, vm, info) {
      console.error({
        error: err,
        vm,
        info,
      });

      return false;
    },
    renderError(h, err) {
      return h('pre', { style: { color: 'red' } }, err.toString());
    },
  });
}

Vue.mixin({
  beforeRouteLeave(to, from, next) {
    rightDrawer.opened = false;
    if (
      this.$vuetify.breakpoint.smAndDown &&
      this.leftDrawer &&
      this.leftDrawer.opened
    ) {
      this.leftDrawer.opened = false;
    }
    next();
  },
  metaInfo: {
    title: process.env.VUE_APP_NAME || 'Oceaneye',
  },
  data() {
    return {
      topBar,
      rightDrawer,
      leftDrawer,
      isMounted: false,
    };
  },
  computed: {
    ...mapState('auth', {
      currentUser: 'user',
    }),
  },
  methods: {
    ...globalMixin.methods,
    getMedia(data, category = 'photos') {
      try {
        return data.media[category][0].url;
      } catch (e) {
        return '/placeholder.jpg';
      }
    },
    getLocationString(location) {
      if (!location || !location.lat || !location.lng) {
        return '';
      }
      return `${location.lat}, ${location.lng}`;
    },
  },
  async mounted() {
    await this.$nextTick();
    this.isMounted = true;
  },
});

export default globalMixin;
